import React, { Component, PropTypes } from 'react'
import RaisedButton from 'material-ui/RaisedButton';
import Divider from 'material-ui/Divider';
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';

export default class AddQuery extends Component {
  constructor (props) {
    super(props)
    this.changeQuery = this.changeQuery.bind(this)
		this.addQuerySubmit = this.addQuerySubmit.bind(this)
		
    this.state = {
      query: '',
			sport: '',
      loading: false
    }
  }

  changeQuery (e) {
    this.setState({ query: e.target.value })
  }

	addQuerySubmit (e) {
		e.preventDefault();
		this.setState({ loading: true})
		if (this.state.query) {
			this.props.onAddQueryClick(this.state.query)
		}
		this.setState({query: ""})
		this.setState({ loading: false})
	}

  render() {
    const { sport } = this.props

    return (
			<div>
			  <Paper zDepth={2}>
        <h2>Add Query</h2>
          <p>
              {sport.toUpperCase()}
					 </p>
					<Divider />
          <TextField
              value={this.state.query}
              hintText='Query'
              onChange={this.changeQuery} />
					<Divider />
          <div>
            <RaisedButton onClick={this.addQuerySubmit } disabled={this.state.loading}>Add Query</RaisedButton>
          </div>
      </Paper>
		</div>
    )
  }
}

AddQuery.propTypes = {
  onAddQueryClick: PropTypes.func.isRequired,
	sport: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/AddQuery.jsx